import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/height-calculator',
  component: () => import('../../routes/HeightCalculator.svelte'),
  card: {
    id: 'height-calculator',
    title: 'Height Calculator',
    description: 'Predict your child\'s adult height based on parental heights using the Khamis-Roche mid-parent height method.',
    icon: 'height',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/height-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Height Calculator – Predict Adult Height from Parents | Khamis-Roche Method',
    description:
      'Free height calculator predicts adult height from parental heights using the Khamis-Roche mid-parent height method. Enter mother and father height to estimate your child\'s future height.',
  },
};

export default meta;
